import React, { useEffect, useState } from 'react';
import './Style/common.css';
import './Style/header.css';
import './Style/DoAgain.css';
import activity_icon_lesson from './Image/activity_icon_lesson.png';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Common/Header';
interface Activity {
  dicfilename?: string;
  lessoncode: string;
  unitcode: string;
  chaptercode: string;
  activitytype: string;
  howshifted: string | null;
  completedflag: string | null;
  lastscore: number | null;
  lastdoneon: string | null;
  ChildShortDesc: string;
  FileID?: string;
  LevelNo?: number;
  DicCode?: string;
  type?: string;
}

interface WlpResponse {
  activities: Activity[];
  recent_lessons: Activity[];
}

const DoAgainPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [WlpBtnText, setWlpBtnText] = useState<string>("");
  const [WlpProgress, setWlpProgress] = useState<string>("");
  const [selectedActivity, setSelectedActivity] = useState<string>("");
  const [data] = useState<WlpResponse | null>(() => {
    if (location.state?.data) {
      sessionStorage.setItem("DoAgainData", JSON.stringify(location.state.data));
      return location.state.data;
    }
    
    const saved = sessionStorage.getItem("DoAgainData");
    return saved ? JSON.parse(saved) : null;
  });
  const [currentActivityIndex, setCurrentActivityIndex] = useState<number>(0);

  useEffect(() => {
    const savedIndex = sessionStorage.getItem('currentActivityIndex');
    if (savedIndex !== null) {
      setCurrentActivityIndex(parseInt(savedIndex, 10));
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem('currentActivityIndex', currentActivityIndex.toString());
  }, [currentActivityIndex]);

  const getActivityLink = (activity: Activity): string => {
    const { activitytype, lessoncode, DicCode, ChildShortDesc } = activity;
    const currentPath = window.location.pathname + window.location.search;
    const calledFromParam = `&calledFrom=${encodeURIComponent(currentPath)}`;
    const hwidParam = "&hwid=null";

    if (activitytype === "G") {
      return `/STUDENT/Tutorials/Game?LsnTestCode=${lessoncode + "_E"}${calledFromParam}${hwidParam}`;
    }
    if (activitytype === "T") {
      return `/STUDENT/Tutorials/ConfirmTest?DicCode=${DicCode}&LsnTestCode=${lessoncode}&name=${encodeURIComponent(ChildShortDesc)}${calledFromParam}${hwidParam}`;
    }
    if (activitytype === "L") {
      return `/STUDENT/Tutorials/Tutorial?id=${lessoncode + "_E"}&name=${encodeURIComponent(ChildShortDesc)}&folder=${DicCode}${calledFromParam}${hwidParam}`;
    }
    return "";
  };

  const handleStartActivity = () => {
    const currentIndex = currentActivityIndex;
    const activity = data?.activities[currentIndex];

    if (!activity) return;

    // Update sessionStorage for the current activity
    sessionStorage.setItem("LsnTestCode", activity.lessoncode || "");
    sessionStorage.setItem("UnitCode", activity.unitcode || "");
    sessionStorage.setItem("ChapterCode", activity.chaptercode || "");
    if (activity.DicCode) {
      sessionStorage.setItem("SelectedDICFile", activity.DicCode);
    }

    // Navigate to the activity link
    const link = getActivityLink(activity);
    if (link) {
      navigate(link);
    }

    // Update the current activity index for the next activity
    const nextIndex = currentIndex + 1;
    if (nextIndex < data?.activities.length) {
      setCurrentActivityIndex(nextIndex);
      setSelectedActivity(data.activities[nextIndex].ChildShortDesc);
    } else {
      // Loop back to the first activity if the last one is completed
      setCurrentActivityIndex(0);
      setSelectedActivity(data.activities[0].ChildShortDesc);
    }
  };

  return (
    <form id='form1'>
      <Header />
      <a
        href="/DoAgain"
        className="back-to-top">Back to Top</a>
      <a
        href="DoAgain"
        className="back-to-bottom" id="back_to_bottom_link">Back to Top</a>
      <div id="main_top_container">

        <div id="divSubjectContainer" className="subject_container" >
          <div id="wlp_add_activity" >
            <p style={{paddingTop: '40px'}}>
              <span className="title_text title_textT wlp_add_activity_title_text">Select your activity to Do Again</span>
            </p>
            <div className="activity_btn_and_tip_container">
              <div className="tip_container">
                <label id="lblWLPText" >Practice activity</label>
              </div>
              <a id="lnkStartActivity"
                className="activity_btn"
                style={{ cursor: 'pointer' }}
                onClick={() => handleStartActivity()} >
                <span
                  id="spnWLPicon"
                  className={`activity_icon ${
                    data?.activities[currentActivityIndex]?.type?.toLowerCase() === "test" ||
                    data?.activities[currentActivityIndex]?.activitytype?.toLowerCase() === "t"
                      ? "wlp_list_current_activity_icon_test"
                      : data?.activities[currentActivityIndex]?.activitytype?.toLowerCase() === "g"
                      ? "wlp_list_current_activity_icon_game"
                      : "wlp_list_current_activity_icon_lesson"
                  }`}
                ></span>
                <label id="lblActivityName" >{data?.activities[currentActivityIndex]?.ChildShortDesc}</label>
                <span className="button_right_text">
                  <span id="lblWLPHeading" >GET STARTED</span>
                </span>
              </a>
            </div>
            <div id="divWLPCompletedContainer" className="completed_box"
            // style={{ display: "none" }}
            >
              <a href='DoAgain'>Weekly lesson plan completed</a>
            </div>
            <div
              id="english_lesson_plan_list"
              className="lesson_plan_list_container"
              style={{ display: "block" }}
            >
              {data?.activities?.map((activity: any, index: number) => (
                <div
                  className="wlp_list_item_row"
                  key={index}
                  onClick={() => setCurrentActivityIndex(index)}
                  style={{ cursor: "pointer" }}
                >
                <div
                  className={`wlp_list_current_activity_icon ${
                    activity.type.toLowerCase() === "test" ||
                    activity.activitytype.toLowerCase() === "t"
                      ? "wlp_list_current_activity_icon_test"
                      : activity.activitytype.toLowerCase() === "g"
                      ? "wlp_list_current_activity_icon_game"
                      : "wlp_list_current_activity_icon_lesson"
                  }`}
                ></div>
                  <div className="wlp_list_current_activity_name">
                    <p>{activity.ChildShortDesc}</p>
                  </div>
                  <div className="wlp_list_current_activity_percentage">
                    <p>{activity.lastscore !== null ? `${activity.lastscore}%` : ""}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* <div className="subject_middle_gap"></div> */}

            <div className="button_box">
              <div id="wlp_add_activity_cancel_btn" className="general_btn two_btn_lightbox">
                <a id="lnkbtnCancel" href='/STUDENT/MSR/StudyRoom' >Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default DoAgainPage;
